import type { API } from 'chessboard/api/config/types';
import { DeprecationWarnings } from 'chessboard/api/config/deprecation-warnings';
import { formatForMarkingsAPI } from 'chessboard/model/marking/format-for-markings-api';
import type { Game } from 'chessboard/model/game/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import { createCoreEvent } from 'chessboard/core/model/create-core-event';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the mark method.
 */
export function createMark(context: API.Context) {
  /**
   * A wrapper on the JCE mark method.
   */
  return function mark(
    marking: Game.Node.Api.Marking.Model,
    isNodeMarking?: boolean,
    options?: Markings.WhereOptions,
  ): API.Response {
    console.warn(DeprecationWarnings.Mark); // eslint-disable-line

    const { api } = context;
    const markings = <Markings.API>api.markings;

    const formattedMarkings = formatForMarkingsAPI(marking, {
      node: options?.node ?? isNodeMarking,
      persistent: options?.persistent ?? true,
    });

    markings.addMany(formattedMarkings);

    return createCoreEvent(Core.APIEvents.Mark, formattedMarkings);
  };
}
